import type { FC } from 'react';

/**
 * @deprecated
 * If the logo you need comes from the Organisation Service,
 * use `OrganisationLogo` instead.
 */
export const MonolithOperatorLogo: FC<{
  src: string;
  name: string;
  testId?: string;
}> = ({ src, name, testId }) => {
  return (
    <img
      src={
        // stories use absolute urls, but real api uses relative ones
        src.startsWith('https://') ? src : PRISMA_CONFIG.monolithUrl + src
      }
      alt={`Logo of ${name}`}
      className="mx-auto my-0 block h-[6rem] w-[13rem] object-contain"
      data-testid={testId}
    />
  );
};
